// 安全地创建 PC 端消息 API
let pcMessageApi = null;
let isInitialized = false;

// 初始化 naive-ui API
const initPcMessageApi = async () => {
	if (isInitialized || !import.meta.client) return;

	try {
		const { createDiscreteApi } = await import("naive-ui/es/discrete");
		const { message } = createDiscreteApi(["message"]);
		pcMessageApi = message;
		isInitialized = true;
	} catch (error) {
		console.error("Failed to initialize naive-ui message API:", error);
	}
};

// 移动端消息方法（假设使用 vant 或其他移动端 UI 库）
const mobileMessageMap = {
	success: msg => {
		try {
			if (typeof showSuccessToast === "function") {
				showSuccessToast({
					message: String(msg),
					duration: 2000,
					className: "app-mobile-success-toast",
					wordBreak: "break-word",
				});
			} else {
				console.log(`[Success]: ${msg}`);
			}
		} catch (e) {
			console.error("Failed to show mobile success toast:", e);
		}
	},
	error: msg => {
		try {
			if (typeof showFailToast === "function") {
				showFailToast({
					message: String(msg),
					duration: 2000,
					className: "app-mobile-success-toast",
					wordBreak: "break-word",
				});
			} else {
				console.error(`[Error]: ${msg}`);
			}
		} catch (e) {
			console.error("Failed to show mobile error toast:", e);
		}
	},
	info: msg => {
		try {
			if (typeof showToast === "function") {
				showToast({
					message: String(msg),
					duration: 2000,
					className: "app-mobile-success-toast",
					wordBreak: "break-word",
				});
			} else {
				console.log(`[Info]: ${msg}`);
			}
		} catch (e) {
			console.error("Failed to show mobile info toast:", e);
		}
	},
	warning: msg => {
		try {
			if (typeof showToast === "function") {
				showToast({
					message: String(msg),
					duration: 2000,
					className: "app-mobile-success-toast",
					wordBreak: "break-word",
				});
			} else {
				console.warn(`[Warning]: ${msg}`);
			}
		} catch (e) {
			console.error("Failed to show mobile warning toast:", e);
		}
	},
	default: msg => {
		try {
			if (typeof showToast === "function") {
				showToast({
					message: String(msg),
					duration: 2000,
					className: "app-mobile-success-toast",
					wordBreak: "break-word",
				});
			} else {
				console.log(`[Message]: ${msg}`);
			}
		} catch (e) {
			console.error("Failed to show mobile default toast:", e);
		}
	},
};

// PC 端消息方法
const pcMessageMap = {
	success: async msg => {
		try {
			await initPcMessageApi();
			pcMessageApi?.success(msg) || console.log(`[Success]: ${msg}`);
		} catch (e) {
			console.error("Failed to show PC success message:", e);
		}
	},
	error: async msg => {
		try {
			await initPcMessageApi();
			pcMessageApi?.error(msg) || console.error(`[Error]: ${msg}`);
		} catch (e) {
			console.error("Failed to show PC error message:", e);
		}
	},
	info: async msg => {
		try {
			await initPcMessageApi();
			pcMessageApi?.info(msg) || console.log(`[Info]: ${msg}`);
		} catch (e) {
			console.error("Failed to show PC info message:", e);
		}
	},
	warning: async msg => {
		try {
			await initPcMessageApi();
			pcMessageApi?.warning?.(msg) || console.warn(`[Warning]: ${msg}`);
		} catch (e) {
			console.error("Failed to show PC warning message:", e);
		}
	},
	default: async msg => {
		try {
			await initPcMessageApi();
			pcMessageApi?.info(msg) || console.log(`[Message]: ${msg}`);
		} catch (e) {
			console.error("Failed to show PC default message:", e);
		}
	},
};

/**
 * 显示跨端消息提示
 * @param {string} msg 要显示的消息内容
 * @param {string} type 消息类型，默认为 'default'
 */
const showMessage = async (msg, type = "default") => {
	if (!msg) {
		console.warn("showMessage: empty message provided");
		return;
	}

	try {
		// 安全地获取Nuxt应用实例
		let isMobile = false;
		try {
			if (import.meta.client) {
				// 尝试获取Nuxt应用实例
				const nuxtApp = useNuxtApp();
				isMobile = nuxtApp.$isMobile || false;
			}
		} catch (nuxtError) {
			// 如果无法获取Nuxt实例，使用浏览器API检测
			if (import.meta.client && typeof window !== "undefined") {
				isMobile =
					window.innerWidth <= 768 ||
					/Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
			}
		}

		if (isMobile) {
			const showMethod = mobileMessageMap[type] || mobileMessageMap.default;
			showMethod(msg);
		} else {
			const showMethod = pcMessageMap[type] || pcMessageMap.default;
			await showMethod(msg);
		}
	} catch (error) {
		console.error("Failed to show message:", error);
		// 降级处理
		console.log(`[${type}]: ${msg}`);
	}
};

export default showMessage;
